import cx from 'classnames'
import Styles from './SectionHeader.module.scss'
import { Button } from './Button'
import { ReactNode } from 'react'

interface SectionHeaderProps {
  label: string
  isExpanded?: boolean
  isExpandable?: boolean
  onPress: () => void
  action?: ReactNode
}

const SectionHeader = ({ label, isExpanded = false, isExpandable = true, onPress, action }: SectionHeaderProps) => (
  <div
    className={cx(Styles.root, {
      [Styles.expanded]: isExpanded,
    })}
  >
    <Button withChevron={isExpandable} onPress={onPress}>
      {label}
    </Button>
    {action}
  </div>
)

export { SectionHeader }
